import React from "react";

import CustomSelect from "../../../../../components/elements/CustomSelect";
import InputField from "../../../../../components/elements/InputField";
import Button from "../../../../../components/elements/Button";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";

export default function ValidationCheckEditor({

                                                  check,

                                                  allowedChecks,

                                                  path,

                                                  updateAtPath,

                                                  onDelete

                                              }){

    const set = (field,value)=>{

        updateAtPath(

            [...path,field],

            value

        );

    };

    return(

        <div className="border rounded-md bg-gray-50 p-5 flex flex-col gap-5">

            <div className="flex items-center gap-5">

                <CustomSelect

                    className="flex-1"

                    value={check.kind}

                    options={allowedChecks}

                    onChange={(e)=>

                        set("kind",e.target.value)

                    }

                />

                <Button onClick={onDelete}>

                    <FontAwesomeIcon icon={faTrash}/>

                </Button>

            </div>

            {/* PROGRAM */}

            {

                [

                    "stdout_exact",

                    "stdout_contains",

                    "stderr_exact",

                    "stderr_contains",

                    "exit_code"

                ].includes(check.kind) && (

                    <InputField

                        title="Expected"

                        value={check.expected || ""}

                        onChange={(e)=>

                            set(

                                "expected",

                                e.target.value

                            )

                        }

                    />

                )

            }

            {

                check.kind==="stdout_regex" && (

                    <InputField

                        title="Regex"

                        value={check.pattern || ""}

                        onChange={(e)=>

                            set(

                                "pattern",

                                e.target.value

                            )

                        }

                    />

                )

            }

            {

                check.kind==="variable_equals" && (

                    <>

                        <InputField

                            title="Variable"

                            value={check.variable || ""}

                            onChange={(e)=>

                                set(

                                    "variable",

                                    e.target.value

                                )

                            }

                        />

                        <InputField

                            title="Expected"

                            value={check.expected || ""}

                            onChange={(e)=>

                                set(

                                    "expected",

                                    e.target.value

                                )

                            }

                        />

                    </>

                )

            }

            {/* SQL */}

            {

                check.kind==="row_count" && (

                    <InputField

                        title="Row Count"

                        type="number"

                        value={check.count || 0}

                        onChange={(e)=>

                            set(

                                "count",

                                Number(e.target.value)

                            )

                        }

                    />

                )

            }

            {

                check.kind==="columns_exact" && (

                    <InputField

                        title="Columns (comma separated)"

                        value={(check.columns || []).join(",")}

                        onChange={(e)=>

                            set(

                                "columns",

                                e.target.value

                                    .split(",")

                                    .map(c=>c.trim())

                            )

                        }

                    />

                )

            }

            {/* WEB */}

            {

                [

                    "selector_exists",

                    "selector_count",

                    "text_exact",

                    "attribute_equals",

                    "css_property_equals"

                ].includes(check.kind) && (

                    <InputField

                        title="Selector"

                        value={check.selector || ""}

                        onChange={(e)=>

                            set(

                                "selector",

                                e.target.value

                            )

                        }

                    />

                )

            }

            {

                check.kind==="selector_count" && (

                    <InputField

                        title="Count"

                        type="number"

                        value={check.count || 0}

                        onChange={(e)=>

                            set(

                                "count",

                                Number(e.target.value)

                            )

                        }

                    />

                )

            }

            {

                check.kind==="attribute_equals" && (

                    <>

                        <InputField

                            title="Attribute"

                            value={check.attribute || ""}

                            onChange={(e)=>

                                set(

                                    "attribute",

                                    e.target.value

                                )

                            }

                        />

                        <InputField

                            title="Expected"

                            value={check.expected || ""}

                            onChange={(e)=>

                                set(

                                    "expected",

                                    e.target.value

                                )

                            }

                        />

                    </>

                )

            }

            {

                check.kind==="css_property_equals" && (

                    <>

                        <InputField

                            title="CSS Property"

                            value={check.property || ""}

                            onChange={(e)=>

                                set(

                                    "property",

                                    e.target.value

                                )

                            }

                        />

                        <InputField

                            title="Expected"

                            value={check.expected || ""}

                            onChange={(e)=>

                                set(

                                    "expected",

                                    e.target.value

                                )

                            }

                        />

                    </>

                )

            }

        </div>

    );

}